import { useSelector } from "react-redux";

export default function useAuth() {
    const auth = useSelector((state) => state.auth);

    if (auth?.accessToken && auth?.user && auth?.user?.role) {
        return { isLoggedIn: true, role: auth?.user?.role };
    } else {
        return { isLoggedIn: false, role: null };;
    }
}
